import { useState } from "react";
import { History, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { istDate } from "@/components/DispatchDatePicker";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const date = "h-10 px-3 rounded-lg border border-[#E0DFD6] text-sm bg-white w-full";

export const ScanDialog = ({ open, onClose, onStarted }) => {
  const [from, setFrom] = useState("2026-06-01");
  const [to, setTo] = useState(istDate(0));
  const [busy, setBusy] = useState(false);
  const start = async () => {
    setBusy(true);
    try {
      await api.post("/sms/scan", { from_date: from, to_date: to });
      toast.success("Full Scan shuru — background me chalega, page band kar sakte ho");
      onStarted();
      onClose();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="sms-scan-dialog">
        <DialogHeader>
          <DialogTitle className="font-['Outfit'] flex items-center gap-2">
            <History className="w-5 h-5 text-[#385C4B]" /> Full Scan — purane saare message
          </DialogTitle>
        </DialogHeader>
        <p className="text-xs text-[#6B6B61]">
          Phone ki saari chats upar se neeche tak khud scroll hongi aur is date range ke saare code save ho jayenge.
          Ye ek baar ka kaam hai. Chats zyada hon to kuch ghante lag sakte hain.
        </p>
        <div className="grid grid-cols-2 gap-3">
          <label className="space-y-1">
            <span className="text-[10px] font-semibold uppercase tracking-[0.16em] text-[#6B6B61]">From date</span>
            <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className={date} data-testid="sms-scan-from" />
          </label>
          <label className="space-y-1">
            <span className="text-[10px] font-semibold uppercase tracking-[0.16em] text-[#6B6B61]">To date</span>
            <input type="date" value={to} onChange={(e) => setTo(e.target.value)} className={date} data-testid="sms-scan-to" />
          </label>
        </div>
        <p className="text-[11px] text-[#9A9A90]">
          Sirf wahi message milenge jo abhi phone ke Google Messages me hain. Phone se delete ho chuke message nahi aayenge.
        </p>
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="h-9 px-4 rounded-full border border-[#E0DFD6] text-sm" data-testid="sms-scan-cancel">Cancel</button>
          <button onClick={start} disabled={busy || !from} data-testid="sms-scan-start"
            className="h-9 px-5 rounded-full bg-[#385C4B] text-white text-sm font-semibold inline-flex items-center gap-1.5 disabled:opacity-50 transition-transform active:scale-95">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} Start scan
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

const STEP = { list: "Chats dhoondh rahe hain", messages: "Purane messages padh rahe hain", done: "Ho gaya", stopped: "Roka gaya" };

export const ScanProgress = ({ scan, onStop }) => {
  if (!scan) return null;
  const running = scan.running;
  const finished = scan.finished || scan.step === "done";
  if (!running && !finished && !scan.stopped) return null;
  const pct = scan.convs_total ? Math.min(100, Math.round((scan.convs_done / scan.convs_total) * 100)) : 0;
  const oldest = scan.oldest_ts ? new Date(scan.oldest_ts).toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", year: "2-digit" }) : "";
  return (
    <div className="bg-white border border-[#E0DFD6] rounded-xl p-4 space-y-2" data-testid="sms-scan-progress">
      <div className="flex items-center justify-between gap-3">
        <span className="text-sm font-semibold text-[#3A3A35]">
          Full Scan · {finished ? "Complete ✓" : scan.stopped && !running ? "Stopped" : STEP[scan.step] || "Running"}
        </span>
        {running && (
          <button onClick={onStop} data-testid="sms-scan-stop"
            className="h-8 px-3 rounded-full border border-[#C8553D]/40 text-[#C8553D] text-xs font-semibold hover:bg-red-50 transition-colors">
            Stop
          </button>
        )}
      </div>
      <div className="h-2 rounded-full bg-[#EFEEE6] overflow-hidden">
        <div className="h-full bg-[#385C4B] transition-[width] duration-500" style={{ width: `${finished ? 100 : pct}%` }} data-testid="sms-scan-bar" />
      </div>
      <div className="text-xs text-[#6B6B61] flex flex-wrap gap-x-4 gap-y-1 tabular-nums" data-testid="sms-scan-stats">
        <span>{scan.convs_done || 0} / {scan.convs_total || 0} chats</span>
        <span>{(scan.messages || 0).toLocaleString("en-IN")} messages</span>
        <span className="text-[#385C4B] font-semibold">{(scan.new_codes || 0).toLocaleString("en-IN")} new codes</span>
        {oldest && !finished && <span>{oldest} tak pahunche</span>}
      </div>
    </div>
  );
};
